
import Vue from 'vue';
import { MessagingContainer } from './messaging';

export default Vue.extend({
  name: 'MessagingScene',
  components: { MessagingContainer },
});
